import type { PlanEditorCategoryGroup, PlanEditorServiceItem } from './planEditorConstants'

type PlanEditorScopeTabProps = {
  isReadonly: boolean
  servicesList: PlanEditorCategoryGroup[]
  onUpdateServiceField: (
    catIndex: number,
    svcIndex: number,
    field: keyof PlanEditorServiceItem,
    value: string | boolean,
  ) => void
  onToggleCategoryAll: (catIndex: number, checkAll: boolean) => void
}

export function PlanEditorScopeTab({
  isReadonly,
  servicesList,
  onUpdateServiceField,
  onToggleCategoryAll,
}: PlanEditorScopeTabProps) {
  return (
    <div className="space-y-4">
      {servicesList.map((cat, catIdx) => {
        const totalIncluded = cat.services.filter((s) => s.isIncluded).length
        const allChecked = totalIncluded === cat.services.length

        return (
          <div key={cat.category} className="glass-card p-4 space-y-3">
            <div className="flex items-center justify-between border-b border-white/[0.06] pb-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent animate-pulse" />
                <h4 className="text-xs font-bold text-text-primary uppercase tracking-wider">{cat.category}</h4>
                <span className="text-[10px] text-text-muted bg-white/[0.04] px-1.5 py-0.5 rounded">
                  {totalIncluded} de {cat.services.length} ativos
                </span>
              </div>
              <button
                type="button"
                onClick={() => onToggleCategoryAll(catIdx, !allChecked)}
                disabled={isReadonly}
                className="text-[10px] text-accent hover:underline font-semibold"
              >
                {allChecked ? 'Desmarcar Todos' : 'Marcar Todos'}
              </button>
            </div>

            <div className="space-y-2">
              {cat.services.map((svc, svcIdx) => (
                <div
                  key={svc.name}
                  className={`flex flex-col md:flex-row md:items-center justify-between gap-3 p-2.5 rounded-lg border transition-all ${
                    svc.isIncluded
                      ? 'bg-[var(--brand-primary-muted)] border-[var(--brand-primary)]/20'
                      : 'bg-white/[0.01] border-white/[0.04] hover:bg-white/[0.02]'
                  }`}
                >
                  <label className="flex items-center gap-2.5 cursor-pointer min-w-0 flex-1">
                    <input
                      type="checkbox"
                      checked={svc.isIncluded}
                      onChange={(e) => onUpdateServiceField(catIdx, svcIdx, 'isIncluded', e.target.checked)}
                      disabled={isReadonly}
                      className="w-4 h-4 accent-accent shrink-0 rounded"
                    />
                    <span className="text-xs text-text-primary font-medium truncate">{svc.name}</span>
                  </label>

                  <div className="flex items-center gap-3 shrink-0">
                    <label className="flex items-center gap-1.5 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={svc.isPartial}
                        onChange={(e) => onUpdateServiceField(catIdx, svcIdx, 'isPartial', e.target.checked)}
                        disabled={isReadonly}
                        className="w-3.5 h-3.5 accent-amber-500 rounded"
                      />
                      <span className="text-[10px] text-text-label uppercase tracking-wider font-semibold">
                        Parcial
                      </span>
                    </label>
                    <input
                      type="text"
                      value={svc.quantity}
                      onChange={(e) => onUpdateServiceField(catIdx, svcIdx, 'quantity', e.target.value)}
                      disabled={isReadonly}
                      placeholder="Ex: 2 campanhas, mensal..."
                      className="w-40 bg-white/[0.04] border border-white/[0.06] text-text-primary text-[10px] rounded px-2 py-1 outline-none focus:border-accent"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
